var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailOutlin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3333 6.66675H6.66666C4.83333 6.66675 3.34999 8.16675 3.34999 10.0001L3.33333 30.0001C3.33333 31.8334 4.83333 33.3334 6.66666 33.3334H33.3333C35.1667 33.3334 36.6667 31.8334 36.6667 30.0001V10.0001C36.6667 8.16675 35.1667 6.66675 33.3333 6.66675ZM33.3333 28.3334C33.3333 29.2501 32.5833 30.0001 31.6667 30.0001H8.33333C7.41666 30.0001 6.66666 29.2501 6.66666 28.3334V13.3334L18.2333 20.5667C19.3167 21.2501 20.6833 21.2501 21.7667 20.5667L33.3333 13.3334V28.3334ZM6.66666 10.0001L20 18.3334L33.3333 10.0001H6.66666Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOutlin);
export default __webpack_public_path__ + "static/media/mail-outlin.3b6dc622.svg";
export { ForwardRef as ReactComponent };